import { BaseDataModel } from "@domain/BaseDataModel";

export class Branch extends BaseDataModel {
	name!: string;
	labAccountNumber!: string;
	salespersonIds!: string[];
	externalLocationId?: string[];
}
